<div class="header {{color}}">
  <div class="left">
    <h3>{{ title }}</h3>
  </div>
  <ng-content select="[status]"></ng-content>
</div>
